import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { translations } from '../../translations/translations';
import './ContactMapSection.css';
import Footer from '../Footer/Footer';
import { MapPin, Phone, Mail } from "lucide-react";

const ContactMapSection = () => {
  const { language } = useLanguage();
  const t = translations?.[language] || translations?.pt || {};
  return (
    <>
      <div className="contact-map-container">
        <div className="contact-info">
          <div className="main-text">
            <h3 className="subtitulo">{t.contact.subtitle}</h3>
            <h1>{t.contact.title1}</h1>
            <h1>{t.contact.title2}</h1>
          </div>

          <div className="contact-details">
            {/* LOCATION */}
            <div className="detail-section">
              <h4>{t.contact.visitUs}</h4>
              <div className="detail-item">
                <MapPin className="contact-icon" />
                <p>
                  Tapada de São Domingos<br />
                  ( km 11,8 da EN 108 Porto,  Entre-os-Rios )<br />
                  Zebreiros | Foz do Sousa
                </p>
              </div>
            </div>

            {/* PHONE + EMAIL SIDE BY SIDE */}
            <div className="contact-row">
              <div className="detail-section">
                <h4>{t.contact.phoneNumber}</h4>
                <div className="detail-item">
                  <Phone className="contact-icon" />
                  <p>
                    +351 224 540 858<br />
                    +351 935 280 777
                  </p>
                </div>
              </div>

              <div className="detail-section">
                <h4>{t.contact.email}</h4>
                <div className="detail-item">
                  <Mail className="contact-icon" />
                  <p>tapada.de.s.domingos@gmail.com</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* MAP */}
        <div className="map-container">
          <iframe
            title="Google Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2302.870054899278!2d-8.509701525040924!3d41.07270247134158!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd247d963c8384dd%3A0xa17153ad2ffdc8fb!2sTapada%20de%20S%C3%A3o%20Domingos!5e1!3m2!1spt-PT!2spt!4v1760658344757!5m2!1spt-PT!2spt"
            width="100%"
            height="100%"
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ContactMapSection;
